// packages/umisis/user-manager/resources/js/menus/left.js

export default {
  items: [
    {
      // The Key: namespace.section.key
      title: 'userManager.nav.title',
      id: 'user-manager',
      to: null,
      icon: 'users',
      sortOrder: 20,
      expanded: true,
      children: [
        {
          title: 'userManager.nav.users',
          to: { name : 'UserManagerIndexPage'},
          icon: 'user',
          sortOrder: 10,
        },
        {
          title: 'userManager.nav.roles',
          to: { name : 'UserRolesManagerIndexPage'},
          icon: 'shield-checkered',
          sortOrder: 20,
        }
      ]
    }
  ]
};
